"use client";

export default function VideoSection() {
  const videos = [
    { id: "1", thumbnail: "/image/gallery/video-1.webp", youtubeId: "RQLLNa66N74" },
    { id: "2", thumbnail: "/image/gallery/video-2.webp", youtubeId: "b03cefHhJZg" },
    { id: "3", thumbnail: "/image/gallery/video-3.webp", youtubeId: "b03cefHhJZg" },
    { id: "4", thumbnail: "/image/gallery/video-4.webp", youtubeId: "b03cefHhJZg" },
    { id: "5", thumbnail: "/image/gallery/video-5.webp", youtubeId: "Uwj764qVNWs" },
    { id: "6", thumbnail: "/image/gallery/video-6.webp", youtubeId: "b03cefHhJZg" },
  ];

  return (
    <section className="bg-background px-4 sm:px-6 xl:px-10 py-[60px] xl:py-[120px]">
      <div className="w-full max-w-[1440px] mx-auto flex flex-col gap-8 xl:gap-[60px]">
        
        {/* Heading + Description */}
        <div className="flex flex-col gap-4 xl:gap-[30px]">
          <h2 className="font-oswald font-medium text-[28px] sm:text-[42px] xl:text-[60px] leading-[1.2] xl:leading-[80px] tracking-[0.2px] uppercase text-neutral-500 max-w-[894px]">
            What Experts & Creators Are Saying About Guniwheel™
          </h2>
          <p className="font-roboto font-normal text-[14px] sm:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300 max-w-[1360px]">
            Explore real workshop footage, reviews, and demonstrations from mechanics, towing companies, and automotive creators who rely on Guniwheel™ daily. Click any video to watch directly on YouTube.
          </p>
        </div>

        {/* Videos Grid */}
        <div className="flex flex-col gap-4 xl:gap-[20px]">
          {/* Top row - 2 large + 1 small */}
          <div className="flex flex-col xl:flex-row gap-4 xl:gap-[20px]">
            {/* Video 1 - Large */}
            <a
              href={`https://www.youtube.com/watch?v=${videos[0].youtubeId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="relative group rounded-[12px] overflow-hidden w-full xl:w-[520px] h-[300px] xl:h-[488px]"
            >
              <img
                src={videos[0].thumbnail}
                alt="Video 1 thumbnail"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-white rounded-md px-3 py-2 flex items-center gap-2">
                <svg className="w-4 h-4 text-red-600" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span className="font-roboto font-medium text-[12px] uppercase text-neutral-900">
                  Watch on YouTube
                </span>
              </div>
            </a>

            {/* Video 2 - Large */}
            <a
              href={`https://www.youtube.com/watch?v=${videos[1].youtubeId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="relative group rounded-[12px] overflow-hidden w-full xl:w-[520px] h-[300px] xl:h-[488px]"
            >
              <img
                src={videos[1].thumbnail}
                alt="Video 2 thumbnail"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-white rounded-md px-3 py-2 flex items-center gap-2">
                <svg className="w-4 h-4 text-red-600" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span className="font-roboto font-medium text-[12px] uppercase text-neutral-900">
                  Watch on YouTube
                </span>
              </div>
            </a>

            {/* Video 3 - Small */}
            <a
              href={`https://www.youtube.com/watch?v=${videos[2].youtubeId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="relative group rounded-[12px] overflow-hidden w-full xl:w-[280px] h-[300px] xl:h-[488px]"
            >
              <img
                src={videos[2].thumbnail}
                alt="Video 3 thumbnail"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-white rounded-md px-3 py-2 flex items-center gap-2">
                <svg className="w-4 h-4 text-red-600" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span className="font-roboto font-medium text-[12px] uppercase text-neutral-900">
                  Watch on YouTube
                </span>
              </div>
            </a>
          </div>

          {/* Bottom row - 1 small + 2 large */}
          <div className="flex flex-col xl:flex-row gap-4 xl:gap-[20px]">
            {/* Video 4 - Small */}
            <a
              href={`https://www.youtube.com/watch?v=${videos[3].youtubeId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="relative group rounded-[12px] overflow-hidden w-full xl:w-[280px] h-[300px] xl:h-[488px]"
            >
              <img
                src={videos[3].thumbnail}
                alt="Video 4 thumbnail"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-white rounded-md px-3 py-2 flex items-center gap-2">
                <svg className="w-4 h-4 text-red-600" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span className="font-roboto font-medium text-[12px] uppercase text-neutral-900">
                  Watch on YouTube
                </span>
              </div>
            </a>

            {/* Video 5 - Large */}
            <a
              href={`https://www.youtube.com/watch?v=${videos[4].youtubeId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="relative group rounded-[12px] overflow-hidden w-full xl:w-[520px] h-[300px] xl:h-[488px]"
            >
              <img
                src={videos[4].thumbnail}
                alt="Video 5 thumbnail"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-white rounded-md px-3 py-2 flex items-center gap-2">
                <svg className="w-4 h-4 text-red-600" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span className="font-roboto font-medium text-[12px] uppercase text-neutral-900">
                  Watch on YouTube
                </span>
              </div>
            </a>

            {/* Video 6 - Large */}
            <a
              href={`https://www.youtube.com/watch?v=${videos[5].youtubeId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="relative group rounded-[12px] overflow-hidden w-full xl:w-[520px] h-[300px] xl:h-[488px]"
            >
              <img
                src={videos[5].thumbnail}
                alt="Video 6 thumbnail"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-white rounded-md px-3 py-2 flex items-center gap-2">
                <svg className="w-4 h-4 text-red-600" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span className="font-roboto font-medium text-[12px] uppercase text-neutral-900">
                  Watch on YouTube
                </span>
              </div>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
